module.exports = __webpack_public_path__ + "img/projek-kawwinai.976c48ca.png";